/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto
 */
export interface CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto {
    /**
     * Array of associated component-type IDs
     * @type {Array<string>}
     * @memberof CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto
     */
    associatedComponentTypeIds: Array<string>;
}

/**
 * Check if a given object implements the CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto interface.
 */
export function instanceOfCreateAssetTypeSubsystemComponentClassComponentTypeRequestDto(value: object): value is CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto {
    if (!('associatedComponentTypeIds' in value) || value['associatedComponentTypeIds'] === undefined) return false;
    return true;
}

export function CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoFromJSON(json: any): CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto {
    return CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoFromJSONTyped(json, false);
}

export function CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'associatedComponentTypeIds': json['associatedComponentTypeIds'],
    };
}

export function CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoToJSON(json: any): CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto {
    return CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoToJSONTyped(json, false);
}

export function CreateAssetTypeSubsystemComponentClassComponentTypeRequestDtoToJSONTyped(value?: CreateAssetTypeSubsystemComponentClassComponentTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'associatedComponentTypeIds': value['associatedComponentTypeIds'],
    };
}

